var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-sidebar',{attrs:{"id":_vm.id,"sidebar-class":"sidebar-right","bg-variant":"white","right":"","backdrop":"","shadow":"","title":_vm.title},on:{"hidden":_vm.hidden,"shown":_vm.shown}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }